export default {
  "meeting": {
    applyrecurring: 'Өөрчлөлтүүд шинэ давтагдах хуваарьт хэрэгжинэ. Өмнөх уулзалтууд өөрчлөгдөхгүй.',
    recurrenceDescribeTwo: '{start}-с {end} хүртэл {loopPulse} долоо хоног тутам {week} гарагт давтагдана',
    wanttodeletethemeetingfollowTwo: 'Сонгосон уулзалт болон түүнээс хойших бүх давтагдах уулзалтыг устгах уу?',
    loopCycleSelectTips: 'Давтах долоо хоногийн өдрөө сонгоно уу.',

    export: 'Экспортлох',
    exportMeetingFileFuncTipsTitle: 'Экспорт баталгаажуулах',
    exportMeetingFileFuncTipsContentOne: 'Шүүлтүүр тохируулаагүй байна. Систем нь анхдагчаар тухайн жилийн уулзалтын мэдээллийг экспортлоно.',
    exportMeetingFileFuncTipsContentTwo: 'Өөр хугацааны уулзалтыг экспортлохын тулд эхлээд хүссэн шүүлтүүрээ тохируулна уу.',

    myMeetingSearch: 'Миний уулзалтууд',
    meetingTimeSearch: 'Уулзалтын цаг',
    meetingRoomsSearch: 'Хурлын өрөө',

    Recurring: 'Давталт:',
    wanttodeletethemeetingfollow: 'Та энэ уулзалт болон дараах бүх уулзалтыг устгахдаа итгэлтэй байна уу?',
    endTimeCannotBeforeBeginTime: 'Дуусах огноо эхлэх огнооноос өмнө байж болохгүй',
    Thismeeting: 'Энэ уулзалт',
    Recurringmeeting: 'Давтагдах уулзалт',
    Checkin: 'Бүртгүүлэх:',
    checkinTip: 'Идэвхжүүлсний дараа оролцогчид Өрөөний хуваарийн QR кодыг уншуулж бүртгүүлэх боломжтой.',
    Recurrence_Setrecurrence: 'Давталт тохируулах',
    Recurrence_Start: 'Эхлэх',
    Recurrence_RepeatEvery: 'Давтах давтамж',
    Recurrence_Week: '7 хоног',
    Recurrence_end: 'Дуусах',
    recurrenceDescribe: '{start}-с {end} хүртэл {week} тутам давтагдана',
    Recurrence_DoesnotRepeat: 'Давтахгүй',
    Recurrence_Weekly: 'Долоо хоног бүр',

    AddressBookUser: 'Хэрэглэгч',
    AddressBookPhonebook: 'Хаягийн дэвтэр',

    RoomByPeopleNum1: '2 хүн ба түүнээс доош',
    RoomByPeopleNum2: '3-6 хүн',
    RoomByPeopleNum3: '7-10 хүн',
    RoomByPeopleNum4: '11-15 хүн',
    RoomByPeopleNum5: '16-20 хүн',
    RoomByPeopleNum6: '21-30 хүн',
    RoomByPeopleNum7: '30-аас дээш хүн',

    whoAreBound: 'Системийн данстай холбогдсон хэрэглэгчид уулзалтыг системийн календарь дээр харах боломжтой. Имэйл хаяг оруулсан хэрэглэгчид имэйлээр мэдэгдэл хүлээн авна. Мэдэгдэл авахын тулд [Миний профайл]-д мэдээллээ бөглөнө үү.',

    AttendessMeeting: 'Оролцогчид:',
    SelectAttendessMeetingTip: 'Оролцогчид сонгох',

    MeetingFilter: 'Уулзалтын шүүлтүүр',
    HostedbyMe: 'Миний зохион байгуулсан',
    Invitedby: 'Миний оролцсон',
    Otherby: 'Бусад',

    "AddressIsDuplicated": "Холбогчийн и-мэйл давхцаж байна",
    "meetingExpired": "Дууссан",
    titlePhoneFormat: 'Утас зөвхөн тоо, () + ба - тэмдэгт оруулах боломжтой.',
    "selectField": "Файлыг сонгоно уу",
    "Limit255": "Файлын нэр 255 тэмдэгтээс их байж болохгүй",
    "nameLimit25": "Нэр 25 тэмдэгтээс их байж болохгүй",
    "emailLimit50": "Имэйл 50 тэмдэгтээс их байж болохгүй",
    "emailFormatError": "Зөв имэйл хаяг оруулна уу",
    "phoneLimit11": "Утасны дугаар хамгийн ихдээ 11 оронтой байж болно",
    "ParticipantsEmail": "Оролцогчийн имэйл:",
    "listIsEmpty": "Жагсаалт хоосон байна",
    "Startimporting": "Татаж эхлэх",
    "Selectfile": "Файл сонгох",
    "Importfile": "Файл оруулах",
    "ImportfileTip": "*Зөвхөн Outlook форматтай CSV (.csv) болон vCard (.vcf) файлуудыг импортлоход дэмжинэ.",
    "addParticipants": "Оролцогч нэмэх",
    "multiselectdeselect": "Шошго устгах зөвлөмж",
    "multiselectselected": "Сонгосон зөвлөмж",
    "enterOrSelectALabel": "Оролцогчийн имэйл сонгоно уу",
    "deleTitleContact": "Та энэ холбоог устгахдаа итгэлтэй байна уу?",
    "delTitleContactContent": "Холбоог устгах уу?",
    "deleteContactTitle": "Устгах холбоог сонгоно уу",
    "editcontact": "Холбоо засах",
    "Name": "Нэр",
    "email": "Имэйл",
    "telephoneNumber": "Утас",
    "Addcontact": "Холбоо нэмэх",
    "Importcontactfile": "Холбоо оруулах",
    "AddressBook": "Хаягийн дэвтэр",
    "Participants": "Оролцогчид:",

    bindTipContent:"Энэ байгууллага аль хэдийн гуравдагч талын календарьтай холбогдсон байна. Outlook/Teams-аар хурал захиалахыг хүсье.",
    Productupdatenews: 'Шинэ хувилбарын шинэчлэл гарлаа. ',
    bookingPerson: 'Захиалсан',
    "DeleteMeeting": "Уулзалтыг устгах",
    "wanttodeletethemeeting": "Та уулзалтыг устгах уу?",
    "hasbeendeleted": "Уулзалт устгагдсан",
    "theMeetingWasAborted": "Уулзалтыг эрт дуусгах",
    "theMeetingWasAbortedContent": "Та уулзалтыг эрт дуусгах уу?",
    "determineTheAbortTask": "Уулзалтыг эрт дуусгах",
    "theMeetingEndedEarly": "Уулзалт эрт дууслаа.",
    "with": "тайлбар",
    "Other": "Бусад",
    "tasks": "ажлын зөрчил",
    "conflict": "Дараах хурал цаг зөрчилдөж байна:",
    "meetConflicts": "Өнгөрсөн цагийг сонгох боломжгүй",
    "itIsNotAllowedToSelectThePastTime": "Сонгосон",
    "selected": "5 хүртэлх хурлын өрөөг сонгоно уу",
    "noOverFive": "Зөвшөөрлийн санал",
    "approvalOpinions": "Цагийн хязгаарыг давсан тул сонгох боломжгүй",
    "beyondTheTimeLimitItCannotBeSelected": "Эхлэх сар",
    "startMonth": "хооронд",
    "to": "Дуусах сар",
    "stopMonth": "Эхлэл байхгүй",
    "didnTStart": "Явцад байна",
    "ONGOING": "Төгсгөл боллоо",
    "ENDED": "бүх",
    "hasBeen": "захиалгаа хийсэн",
    "booking": "Зөвшөөрөх",
    "Approval": "Хурлын өрөө",
    "MeetingRoom": "Бүх өрөө",
    "AllRoom": "Боломжтой",
    "Available": "Хурал эхлүүлэх",
    "Initiate": "Хурал зөвшөөрөх",
    "MeetingApproval": "Өмнөх сар",
    "PreviousMonth": "Өнөөдөр",
    "Today": "Дараагийн сар",
    "NextMonth": "Жил/Сар",
    "YearMonth": "Цагийн харуулалт",
    "TimeDisplay": "Хурлын нэрийн товчлол",
    "MeetingTitleAbbreviation": "Хурал эхлүүлэх",
    "InitiateMeeting": "Ирээдүйн хурлууд",
    "PendingMeetings": "Бүх хурлууд",
    "AllMeetings": "Одоогоор оролцох хурал байхгүй байна",
    "noMeetings": "Эхлээгүй",
    "NotStarted": "Зохион байгуулагч",
    "Organizer": "Огноо ба цаг",
    "MeetingDateTime": "Байршил",
    "MeetingLocation": "Хурлын сэдэв",
    "MeetingSubject": "Уригдсан хүмүүс",
    "Invited": "Хүлээн зөвшөөрсөн хүмүүс",
    "PeopleAccepted": "Хурлыг засах",
    "EditMeeting": "Хурлыг цуцлах",
    "CancelMeeting": "Хурал эхлүүлэх/Засах",
    "InitiateEditMeeting": "Сэдэв",
    "Subject": "Сэдэв",
    "Presenter": "Туслагч :",
    "DateTime": "Огноо ба цаг",
    "TimeAndZone": "Цагийн бүс",
    "Attendees": "Оролцогчид",
    "Addrequiredattendees": "Шаардлагатай оролцогчдыг нэмэх",
    "SelectRooms": "Өрөөг сонгох",
    "Reminder": "Сануулах",
    "Remindbeforestart": "Эхлэхээс өмнө сануулах",
    "Confirm": "Батлах",
    "topic": "Сэдэв :",
    "topicplace": "Шинэ хурлын нэр :",
    "speaker": "Туслагч :",
    "speakerplace": "Туслагчаас мэдээллийг оруулна уу",
    "DateAndTime": "Огноо ба цаг :",
    "TimeZone": "Цагийн бүс",
    "EndDate": "Төгсгөл огноо",
    "Rooms": "Өрөөнүүд :",
    "Notes": "Тэмдэглэл :",
    "MeetingRoomApproval": "Хурлын өрөөний баталгаа",
    "PendingApproval": "Баталгаажуулах хүлээлт",
    "Approved": "Батлагдсан",
    "nopendingapprovals": "Хүлээгдэж байгаа баталгаанууд байхгүй",
    "Applicant": "Өргөдөл гаргагч",
    "UsageTime": "Хэрэглээний цаг",
    "ApprovalResult": "Баталгаажуулалтын үр дүн",
    "ApprovalComments": "Баталгаажуулалтын сэтгэгдэл",
    "Approve": "Батлах",
    "Reject": "Татгалзах",
    "Search": "Хайх",
    "Filter": "Шүүлт",
    "scanTheQRCodeToSignIn": "QR кодыг уншиж бүртгүүлэх"
  },
  "NPS": {
    "Relay": "Реле",
    "RelaySettings": "Реле тохиргоо",
    "DevicePower": "Төхөөрөмжийн цахилгаан хяналт",
    "DeviceElevation": "Өргөх хяналт",
    "LinageWithNPSPower": "NPS цахилгаан холболт",
    "PresentationSwitch": "Танилцуулгын тумблер",
    "Duplicate": "Давтах",
    "LinkagewithNPSPowe": "NPS цахилгаан холболт",
    "npsTooltip": "USB төхөөрөмжүүдийг зөвхөн HDMI OUT 1-ээр холбогдсон PC хостоор дуудж болно.",
    "nmpTooltip": "'Давтах' товчийг дарж дэлгэцийн агуулгыг бусад дэлгэцүүд дээр тусгах, олон дэлгэц дээр дэлгэцийн мэдээллийг синхрончлох."
  },
  "textTemplate": {
    "template2513": "Гал түймрийн эрсдэлийн шуурхай дамжуулалт",
    "template2514": "Гал түймрийн гарц болон аврах замаар аюулгүй газар руу эвакулагдана уу.",
    "moreTemplate": "Шаблон хязгаарт хүрсэн",
    "add": "Нэмэх",
    "SetTemplate": "Шаблоныг тохируулах",
    "Emergency": "Онцгой",
    "General": "Ерөнхий",
    "BroadcastDevices": "Трансляци төхөөрөмж:",
    "selectBroadcastDevices": "Трансляци төхөөрөмжүүдийг сонгоно уу",
    "All": "Бүгд",
    "AddTemplate": "Шаблон нэмэх",
    "EditTemplate": "Шаблон засварлах",
    "deleteTemplage": "Та сонгосон шаблоныг устгахдаа итгэлтэй байна уу?",
    "title": "Шаблоныг устгах",
    "selectTemplage": "Шаблон сонгоно уу!",
    "DeleteCancelled": "Устгал буцсан!",
    "DeletedSuccessfully": "Амжилттай устгагдсан!",
    "noData": "Шаблон ашиглах боломжгүй, шаблон нэмэхийн тулд баруун дээд булан руу дарна уу",
    "TemplateTitle": "Шаблоны гарчиг:",
    "BroadcastType": "Трансляци төрлийн:",
    "BroadcastTypeDialog": "Трансляци төрлийн:",
    "selectBroadcastType": "Трансляци төрлийг сонгоно уу",
    "BroadcastDuration": "Трансляцийн хугацаа:",
    "BroadcastDevice": "Трансляци төхөөрөмж:",
    "BroadcastContent": "Трансляцийн агуулга:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Алдаа!",
    "mediaTimeStateNotifyErrorContent": "Таны стримингийн үйлчилгээ дууссан байна, хугацаанд нь шинэчлүүлэхийн тулд агенттайгаа холбогдоно уу.",
    "mediaTimeStateNotifyWarnTitle": "Анхааруулга!",
    "mediaTimeStateNotifyWarnContent": "Танай үйлчилгээ одоогийн байдлаар туршилтын байдалд байгаа бөгөөд зөвхөн 3 терминал төхөөрөмжид дамжуулж, шууд дамжуулалт хийх боломжтой.",
    "mediaTimeStateNotifySuccessTitle": "Амжилттай шинэчлэлт",
    "mediaTimeStateNotifySuccessContent": "Таны стримингийн үйлчилгээ хэвийн ашиглалтад бэлэн байна. Баярлалаа.",
    "company": "Компаний нэр:",
    "tableAddress": "Хаяг:",
    "createTime": "Үүсгэсэн огноо:",
    "email": "Имэйл:",
    "phone": "Утас:",
    "Trial": "Туршилт",
    "TrialWorkstation": "Танай үйлчилгээ одоогийн байдлаар туршилтын байдалд байгаа бөгөөд зөвхөн 3 терминал төхөөрөмжид дамжуулж, шууд дамжуулалт хийх боломжтой.",
    "Normal": "Хэвийн",
    "NormalWorkstation": "Таны стримингийн үйлчилгээний хүчинтэй хугацаа:",
    "to": "хүртэл",
    "Advent": "Дараагийн:",
    "AdventWorkstationOne": "Таны стримингийн үйлчилгээ дуусах гэж байна",
    "AdventWorkstationTwo": ", хугацаанд нь шинэчлүүлж, хэвийн ашиглалтад оруулахыг анхаарна уу.",
    "Expired": "Дууссан",
    "ExpiredWorkstation": "Таны стримингийн үйлчилгээ дууссан байна, хугацаанд нь шинэчлүүлж, хэвийн ашиглалтад оруулахыг анхаарна уу."
  },
  "route": {
    "dashboard": "Хянах самбар",
    "i18n": "I18n",
    "Devices": "Төхөөрөмжүүд",
    "Broadcast": "Дамжуулалт",
    "Schedule": "Хуваарь",
    "Resources": "Нөөцүүд",
    "Live": "Стриминг",
    "meetings": "Тамир"
  },
  "navbar": {
    "updates":"Сүүлийн шинэчлэлүүд",
    "logOut": "Гарах",
    "screenfull": "Дэлгэцний бүрэн хэмжээ",
    "oprofile": "Миний профайл",
    "settings": "Тохиргоо",
    "language": "Хэл",
    "BackTianwa": "Tianwa руу буцах",
    "newUserGuide": "Шинэ хэрэглэгчийн гарын авлага"
  },
  "feedback": {
    "Feedback": "Санал",
    "email": "Please leave your email for our feedback.",
    "content": "Манай бүтээгдэхүүнийг сайжруулахын тулд мессеж үлдээнэ үү. Таны саналд баярлалаа.",
    "submit": "Илгээх",
    "emailNoEmpty": "Имэйл хаяг хоосон байж болохгүй",
    "emailTrueRule": "Зөв имэйл форматыг оруулна уу",
    "contentNoEmpty": "Агуулга хоосон байж болохгүй",
    "feedbackSuccess": "Санал амжилттай илгээсэн",
    "feedbackFailed": "Санал илгээхэд алдаа гарсан",
    "emailNoChinese": "Имэйл хаягт хятад тэмдэгт байхгүй байх ёстой",
    "emailLength": "5-50 тэмдэгт урттай байх ёстой",
    "emailSpecialString": "Имэйл хаягт тусгай мөрүүд байж болохгүй"
  },
  "login": {
    checkPasswordTitleTwo: 'Хамгийн багадаа 6 тэмдэгттэй, үсэг болон тоо агуулсан нууц үг тохируулна уу. Тусгай тэмдэгт ашиглах боломжтой (хязгаарлалтгүй).',
    captcha: 'Баталгаажуулах код',
    checkPasswordTitle: 'Нууц үг дор хаяж 6 тэмдэгттэй байх ёстой бөгөөд зөвхөн тооноос бүрдэхгүй',
    "title": "Тавтай морилно уу",
    "logIn": "Нэвтрэх",
    "consoleLogin": "Консол руу нэвтрэх",
    "username": "Хэрэглэгчийн нэр",
    "password": "Нууц үг",
    "any": "ямар ч",
    "thirdparty": "Эсвэл холбогдох",
    "thirdpartyTips": "Орон нутгийн хувилбарыг дуурайх боломжгүй тул өөрийн бизнесийн симуляцитай хослуулна уу!",
    "placeholder": ["Хэрэглэгчийн нэр","Нууц үг","Баталгаажуулах код"],
    "userNameTitle": "Буруу хэрэглэгчийн нэр!",
    "forget": "Мөрдөгдөхгүй юу?",
    "loginTitle0": "Амжилттай нэвтэрлээ!",
    "loginTitle1000": "Хэрэглэгчийн нэр эсвэл нууц үг буруу!",
    "loginTitle1001": "Хэрэглэгчийн нэр ба нууц үгийг бөглөх шаардлагатай!",
    "loginTitle1002": "Баталгаажуулах кодыг бөглөх шаардлагатай!",
    "loginTitle1003": "Хэрэглэгчийн статус хууль бус байна, нэвтрэх амжилтгүй!",
    "loginTitle1004": "Баталгаажуулах кодын алдаа!",
    "loginTitle1005": "Нэвтрээгүй байна, эхлээд нэвтэрнэ үү!",
    "loginTitle1006": "Хоёр нууц үг ялгаатай байна!",
    "loginTitleUserName": "Хэрэглэгчийн нэрийг бөглөх шаардлагатай!",
    "loginTitlePwd": "Нууц үгийг бөглөх шаардлагатай!",
    "loginTitleVercode": "Баталгаажуулах кодыг бөглөх шаардлагатай!",
    "titleLoginNameFormat": "Данс нь тэмдэгтүүдээс эсвэл тэмдэгтүүд болон тооноос бүрдэх ёстой.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Төхөөрөмжүүд",
    "btnRoadcast": "Трансляци",
    "btnResources": "Нөөц",
    "btnLive": "Стриминг",
    "meetings": "Хурал",
    "todaySchedule": "Өнөөдрийн хуваарь",
    "allSkedules": "Бүх хуваарь",
    "details": "Дэлгэрэнгүй",
    "btnStart": "Эхлэх",
    "titleContent": "Сайн уу! Q-NEX консол танд үйлчилж байна. Эхлүүлэх бол!",
    "btnExit": "Гарах"
  },
  "devices": {
    ptzCamera:'PTZ камер',
    "start": "ЭХЛЭХ",
    "stop": "ЗОГСООХ",
    "nmpPowerOff_mandatory": "Мөн Broadcasting (нэмэлт шаардлагагүй) байна",
    "nmpPowerOff_nomandatory": "Мөн Broadcasting (нэмэлт шаардлагагүй). Гүйцэтгэлийг үргэлжлүүлэх үү?",
    "nmpsPowerOff_mandatory": "Зарим NMP-үүд Broadcasting (шаардлагагүй) байна",
    "nmpsPowerOff_nomandatory": "Зарим NMP-үүд Broadcasting (нэмэлт шаардлагагүй) байна. Гүйцэтгэлийг үргэлжлүүлэх үү?",
    "reset": "Төхөөрөмжийг шинэчлэх",
    "displayedInTheControlArea": "Хяналтын төв дээр харуулах",
    "dragOrder": "Засварлах захиалгаа чирч оруулах",
    "areaSettingTwoNotice": "*RS232, AC хяналт, болон алсаас хяналт хийх нь NMP-ийн холболтын байдалтай хамаарна",
    "areaSettingThreeNotice": "*CBX хяналт нь NMP-ийн холболтын байдалтай хамаарна",
    "controlSet": "Хяналтын төвийн тохиргоо",
    "vcbNoLine": "CBX төхөөрөмж онлайн биш байна",
    "vcbNoBound": "CBX төхөөрөмж холбогдоогүй байна",
    "tscNoBound": "RS232 TSC дээр өгөгдөлтэй холбогдоогүй байна. Администраторт мэдэгдэж, хяналтын самбар дээр холбохыг хүснэ үү.",
    "light": "Эрчим хүчний хяналт",
    "vcbpower": "Эрчим хүч",
    "rs232Control": "Цуврал хяналт",

    "CBX": {
    "powerSupplyON": "Power On",
    "powerSupplyOFF": "Power Off",
    "lockScreenON": "Тамга Асаалттай",
    "lockScreenOFF": "Тамга Унтраалттай",
    "childLockON": "Хүүхдийн хамгаалалт Асаалттай",
    "childLockOFF": "Хүүхдийн хамгаалалт Унтраалттай",
    "energySavingON": "Эрчим хүчний хэмнэлт Асаалттай",
    "energySavingOFF": "Эрчим хүчний хэмнэлт Унтраалттай",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Динамик",
    "brightAdjustment": "Гэрэлтүүлэг",
    "other": "Бусад функцууд..."
  },

    "InterfaceOne": "Нэг интерфэйс",
    "InterfaceTwo": "Хоёр интерфэйс",
    "abcStyleP": "Уучлаарай! TSC болон (NMP, MBX, NPS, NDP100, NDP500) зэрэг сонгогдохгүй",
    "masterControl": "гол",
    "powerSupply": "Цахилгаан",
    "RecordingControl": "Бичлэгийн хяналт",
    "RecordingControlSystem": "Лекц бичлэгийн систем",
    "LiquidCrystal": "Интерактив LCD дэлгэц",
    "projector": "Төслийн дэлгэц",
    "othertype": "Бусад",
    "lockScreen": "Тамга",
    "childLock": "Хүүхдийн хамгаалалт",
    "energySaving": "Эрчим хүчний хэмнэлт",
    "signalSourceSwitching": "Оруулах эх сурвалж",
    "volumeAdjustment": "Динамик",
    "brightAdjustment": "Гэрэл",
    "other": "Бусад шинж чанарууд",
    "otherFunction": "Функц",
    "send": "Илгээх",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Агааржуулагч",
    "titleDevices": "Бүлгийн шүүлтүүр:",
    "content": "Хайлт",
    "selectALL": "БҮГДИЙГ СОНГОХ",
    "SelectRecentPage": "Одоогийн хуудас сонгох",
    "controlPanel": "Хяналтын төв",
    "displayInputSwitch": "Дэлгэцийн оролт шилжүүлэгч",
    "chooseINPUTSources": "ОРЛОГО ЭХ СУРВАЛЖУУДЫГ СОНГОХ",
    "speakerVolume": "Аудио хэмжээ",
    "bass": "Басс",
    "treble": "Трис",
    "MICVolume": "MIC Дууны түвшин",
    "AirConditioning": "Агааржуулагч",
    "model": "Загвар",
    "setTemp": "Тохируулах температур",
    "fanSpeed": "Салхины хурд",
    "bold": "Хөдөлгөөн",
    "projectionScreen": "Проекцийн дэлгэц",
    "electronicLock": "Цахилгаан түлхүүр",
    "electronicLock1": "Цахилгаан түлхүүр",
    "selectDevices": "Төхөөрөмж эсвэл төхөөрөмжийн бүлгийг сонгоно уу",
    "isCompelType": "Албан ёсны дамжуулалттай холбоотойгоор төхөөрөмжийн хяналт боломжгүй, дараа дахин оролдож үзнэ үү.",
    "mainPower": "Гол хүч",
    "extraPower": "Нэмэлт хүч",
    "power": "Хүч",
    "hdmiBroadcast": "Трансляци",
    "equipmentState1": "Тай включить",
    "equipmentState2": "Тай унтраах",
    "equipmentState3": "Офлайн",
    "main": "Гол",
    "external": "Гадаад",
    "ProjectionScreen": "Проекцийн дэлгэц",
    "UP": "ДЭЭШ",
    "DOWN": "ТООС",
    "LOCK": "ТҮГЖИХ",
    "UNLOCK": "ТҮГЖЭЭГҮЙ",
    "PleaseDevice": "Зүүн талын төхөөрөмжийг сонгоно уу",
    "RemoteControl": "Алсын удирдлага",
    "Action": "Үйлдэл",
    "Devicefilter": "Төхөөрөмжийн шүүлтүүр",
    "DeviceStatus": "Төлөв",
    "DeviceType": "Төрөл",
    "currentAudioSource": "Одоогийн аудио эх сурвалж",
    "audioSwitching": "Аудио гаралтын тумблер"
  },
  "broadcast": {
    "isBoarding": "(Трансляцид)",
    "last3Days": "СҮҮЛИЙН 3 ӨДӨР",
    "last7Days": "СҮҮЛИЙН 7 ӨДӨР",
    "last30Days": "СҮҮЛИЙН 30 ӨДӨР",
    "historyRecord": "Түүх",
    "SelectDestination": "1.Зорилго сонгох",
    "BroadcastingConsole": "2.Дамжуулалтын консол",
    "Notification": "Мэдэгдэл",
    "btnStop": "Тогтоох",
    "btnStart": "Эхлүүлэх",
    "Letters60": "(60-аас бага тэмдэгт)",
    "Letters300": "(300-аас бага тэмдэгт)",
    "LastingTime": "Тогтмол хугацаа:",
    "Title": "Гарчиг:",
    "Content": "Агуулга:",
    "Cannotquit": "Албан ёсны дамжуулалт",
    "ChooseMedia": "Медиа файлыг сонгох",
    "Broadcasting": "Дамжуулалт",
    "dialogTitle": "Видео ба Аудио нөөц",
    "SortBy": "эрэмбэ",
    "btnBake": "Өмнөхдөө буцах",
    "cancel": "Цуцлах",
    "confirm": "Баталгаажуулах",
    "save": "Хадгалах",
    "coxAll": "Бүх зүйл",
    "PublicCloud": "Нийтийн хадгалах",
    "IndividualCloud": "Хувийн хадгалах",
    "selFile": "Файл эсвэл бүлэг сонгоно уу",
    "StopBroadcast": "Дамжуулалтыг зогсоох",
    "StartBroadcasting": "Дамжуулалтыг эхлүүлэх",
    "StopBroadcasting": "Дамжуулалтыг зогсоох",
    "ForceQuit": "Мөрдлөгөө хийх",
    "PleaseMediaFile": "Медиа файл сонгоно уу",
    "PleaseDevice": "Төхөөрөмж сонгоно уу",
    "broadcast_0": "Дамжуулалтыг эхлүүлэх",
    "broadcast_2500": "Медиа серверт холбох хамгийн их төхөөрөмжийн тоо хэтэрсэн",
    "broadcast_2501": "Дамжуулалтын файл алдаа",
    "broadcast_2502": "Дамжуулалт дууссан",
    "broadcast_2503": "Медиа серверийн мэдээллийг авч чадаагүй",
    "broadcast_2510": "Анхаарах! Та одоогоор туршилтын горимд байгаа бөгөөд 3 терминал төхөөрөмж хүртэл л дамжуулалтын командыг хүлээн авах боломжтой. Сонгосон төхөөрөмжийн тоог шалгана уу.",
    "broadcast_2018": "Стриминг үйлчилгээ хаагдсан.",
    "broadcast_2019": "Стриминг үйлчилгээ дууссан.",
    "broadcast_2512": "Шаблонгийн хэмжээ хэтрэв.",
    "broadcast_2513": "Гал түймрийн тохиолдлын шуурхай дамжуулалт.",
    "broadcast_2514": "Гал түймрийн болон ослын үед аюулгүй байршилд шилжихийн тулд яаралтай гарах гарц болон галыг орхих гараар гарна уу.",
    "broadcast_2006": "Төхөөрөмж олдсонгүй.",
    "broadcast_2": "Дискийн үйлчилгээ хэвийн бус.",
    "broadcast_2515": "Дамжуулах боломжгүй төхөөрөмжийг сонгоно уу.",
    "broadcast_2516": "NMP-ийн хамгийн их д supported дэмжигдсэн зурвасын хэмжээ хэтэрсэн файлуудыг сонгоно уу.",
    "broadcast_2517": "NDP500-ийн хамгийн их д supported дэмжигдсэн зурвасын хэмжээ хэтэрсэн файлуудыг сонгоно уу.",
    "broadcast_Title": "Дамжуулалттай холбоотой анхааруулга.",
    "broadcast_TitleNDP500": "NDP500 Дамжуулалттай холбоотой анхааруулга.",
    "broadcast_content": "Төхөөрөмж нь 4K@30FPS хүртэл дэмжигдэж, хамгийн тохиромжтой зурвасын хэмжээ нь 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 нь 1080P@30FPS хүртэл дэмжигдэж, хамгийн тохиромжтой зурвасын хэмжээ нь 720P@30FPS.",
    "broadcast_noSupported": "Сонгосон дараах видеог дамжуулахад дэмжигдсэнгүй:",
    "broadcast_noSupportedNDP500": "Сонгосон дараах видеог NDP500/600 дээр дамжуулахад дэмжигдсэнгүй:"
  },
  "resources": {
    "uploadNameLengthError": "Файл байршуулсан нэр нь 100 үгсээс их байж болохгүй!",
    "onUploadFile": "Файл байршуулж байхгүй",
    "open": "Нээх",
    "fold": "Нууцлах",
    "close": "Хаах",
    "PublicCloud": "Нийтийн хадгалалт",
    "IndividualCloud": "Хувийн хадгалалт",
    "TransfersHistory": "Д Transfers Түүх",
    "btnDownload": "Татаж авах",
    "btnDelete": "Устгах",
    "btnUploadFile": "Файл байршуулж",
    "btnNewFolder": "Шинэ хавтгай",
    "btnBake": "Өмнөх рүү буцах",
    "coxAll": "Бүгд",
    "uploadError": "Файл байршуулалтын хэмжээ 1ГБ-ыг хэтрэхгүй байх ёстой!",
    "MD5": "MD5 баталгаажуулалт",
    "merge": "Нэгдэх",
    "transcoding": "Төрийн өнгөрөх",
    "uploadFailed": "Файл байршуулалт амжилтгүй болсон",
    "fileError": "Файлыг унших алдаа гарсан, файлыг шалгана уу.",
    "tableName": "Нэр",
    "tableSize": "Хэмжээ",
    "tableType": "Төрөл",
    "tableTimeAdded": "Нэмж оруулсан хугацаа",
    "tableAction": "Үйлдэл",
    "btnRename": "Нэр өөрчлөх",
    "btnMoveTo": "Шилжүүлэх...",
    "ClearAll": "Бүгдийг цэвэрлэх",
    "cancel": "Цуцлах",
    "confirm": "Батлах",
    "save": "Хадгалах",
    "addSuccess": "Амжилттай нэмж оруулсан!",
    "addError": "Нэмэхэд алдаа гарсан!",
    "editSuccess": "Амжилттай зассан!",
    "editError": "Засахад алдаа гарсан!",
    "delSuccess": "Амжилттай устгасан!",
    "delError": "Устгахад алдаа гарсан!",
    "diskError3000": "Нийт хэмжээний багтаамж хэтэрсэн, үйлдэл амжилтгүй болсон!",
    "diskError3001": "Нийтийн зайг хэтэрсэн, үйлдэл амжилтгүй болсон!",
    "diskError3002": "Хувийн зайг хэтэрсэн, үйлдэл амжилтгүй болсон!",
    "diskError3003": "Мэдээллийг олох боломжгүй байна, медиа сервер холбогдсон эсэхийг шалгана уу!",
    "diskError3004": "Хавтгай нэр аль хэдийн байна!",
    "diskError3005": "Хавтгайг авахад алдаа гарсан!",
    "diskError3006": "Нэг түвшинд 99-ээс их хавтгай үүсгэж болохгүй!",
    "diskError3007": "Нэртэй файлын хувьд өөрчлөлт амжилтгүй болсон!",
    "diskError3008": "Нэртэй хавтгайг өөрчлөх үед алдаа гарсан!",
    "diskError3009": "Файл үлдсэн зайг хэтрүүлсэн бөгөөд байршуулалт амжилтгүй болсон!",
    "diskError3010": "Амжилтгүй байршуулсан!",
    "diskError3011": "Файлын шалгалт амжилтгүй болсон, дахин байршуулна уу!",
    "diskError3012": "Хувийн үүлний хаягийг авахад алдаа гарсан, үйлдэл амжилтгүй болсон!",
    "diskError3013": "Олон файлын хослол 100МБ-аас их байж болохгүй, том файлуудыг тусдаа татаж авна уу!",
    "diskError3014": "Нягтруулахад алдаа гарсан, файлыг дахин сонгоно уу!",
    "diskError3015": "Энэхүү үйлдлийг гүйцэтгэхийн тулд зөвшөөрөл хэрэгтэй",
    "downloadError": "Татаж авахад алдаа гарсан!",
    "mobileError": "Шилжүүлэхэд алдаа гарсан!",
    "root": "Бүх файлууд",
    "Name": "Нэр",
    "Size": "Хэмжээ",
    "Type": "Төрөл",
    "uploadFile": "Файл байршуулж",
    "newFolder": "Шинэ хавтгай",
    "tableTime": "Цаг",
    "permission": "Зөвшөөрөл хангалтгүй!",
    "notifyTitle": "Мэдэгдэл",
    "notifyContent": "Хэрэглэгчид хэрэглэх эрх хангалтгүй байна!",
    "sortFileName": "Файлын нэр",
    "sortTime": "Цаг",
    "sortSize": "Хэмжээ",
    "sortType": "Төрөл",
    "moveTo": "Шилжүүлэх...",
    "test": "Шинэ",
    "delTitle": "Устгах уу?",
    "delTitleContent": "Сонгогдсон агуулга нь өгөгдлийн сангаас устгах болно. Энэ үйлдэл нь эргүүлж болохгүй. Та үргэлжлүүлэхэд итгэлтэй байна уу?",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Батлах"
  },
  "userMge": {
    "userName": "Хэрэглэгчийн нэр:",
    "jobNumber": "Ажилтны дугаар:",
    "email": "И-мэйл:",
    "phone": "Утас:",
    "group": "Групп:",
    "oldPassword": "Хуучин нууц үг:",
    "newPassword": "Шинэ нууц үг:",
    "confirmNewPassword": "Шинэ нууц үгийг баталгаажуулах:",
    "btnSave": "Өөрчлөлт хадгалах",
    "titleChangePassword": "Нууц үг солих",
    "titleMyProfile": "Миний профайл",
    "name": "Товч нэр:",
    "error1400": "Хэрэглэгчийн (хаалттай) аккаунт аль хэдийн оршдог, үйлдэл амжилтгүй боллоо!",
    "error1401": "Хэрэглэгчийн (систем үүсгэсэн) аккаунт аль хэдийн оршдог, үйлдэл амжилтгүй боллоо!",
    "error1402": "Групп байхгүй, импорт амжилтгүй боллоо!",
    "error1403": "Мэдээллийн алдаа",
    "error1404": "Зөвшөөрөл хангалтгүй",
    "selUser": "Хэрэглэгчийг сонгоно уу!",
    "error1405": "Үүрэг авахад алдаа гарсан",
    "error1406": "Импортын хэрэглэгчийн мэдээллийн форматаа алдаж байна",
    "error1407": "И-мэйл аль хэдийн оршдог, үйлдэл амжилтгүй боллоо.",
    "error1408": "Утас аль хэдийн оршдог, үйлдэл амжилтгүй боллоо.",
    "editSuccess": "Амжилттай хадгалсан!",
    "ChangePassword": "Нууц үг солих",
    "UserPrivacyAgreement": "Хэрэглэгчийн нууцлалын бодлого"
  },
  "information": {
    "_2602": "Төхөөрөмж оффлайн байна",
    "_2603": "Трансляци амжилтгүй",
    "_2604": "Трансляци тасалдсан",
    "_2605": "Хадгалах орон зай дүүрсэн",
    "_2606": "төгсгөл минутын өмнө",
    "_2607": "төгсгөл цагийн өмнө",
    "_2609": "амжилтгүй, та ",
    "_2609_a": "энд дарна уу ",
    "_2609_time": "цагаа баримтжуулж шийдвэрлэх",
    "userType": "Захирал",
    "unreadNoticeFirst": "Мэдэгдлийг эхлээд унших",
    "sortByTime": "Цаг хугацаагаар эрэмбэлэх",
    "coxRead_1": "Уншсан",
    "coxRead_0": "Уншигдаагүй",
    "allCoxRead": "Бүгдийг уншсанд тэмдэглэх",
    "load": "Түүхийг ачаалж байна...",
    "noData": "Данные байхгүй",
    "viewALLMessages": "Бүх мэдэгдлийг харах"
  },
  "input": {
    "select": "Сонгоно уу",
    "thisField": "Энэ талбарыг бөглөх ёстой.",
    "titleShooleNub60": "60 тэмдэгтээс бага",
    "titleShooleNub300": "300 тэмдэгтээс бага",
    "Offline": "Офлайн"
  },
  "schedule": {
    "OnlyManual": "Зөвхөн гараар",
    "runStartNow": "Үүрэг гүйцэтгэх",
    "runStopNow": "Үүрэг зогсоох",
    "tackExecutionStart": "Үүрэг гүйцэтгэж байна",
    "tackExecutionStop": "Үүрэг гүйцэтгэл зогссон",
    "dehumidification": "Чийгшлийг бууруулах",
    "airSupply": "Агаарын хангамж",
    "masterControl": "гол:",
    "powerSupply": "Хүчдэл",
    "lockScreen": "Тамга",
    "RecordingControl": "Бичлэгийн хяналт",
    "RecordingControlSystem": "Лекц бичлэгийн систем",
    "LiquidCrystal": "Интерактив LCD дэлгэц",
    "projector": "Төслийн аппарат",
    "othertype": "Бусад",
    "childLock": "Хүүхдийн хамгаалалт",
    "energySaving": "Эрчим хүч хэмнэлт",
    "signalSourceSwitching": "Оруулгын эх сурвалж",
    "other": "Бусад онцлог:",
    "otherFunction": "Функц",
    "send": "Илгээх",
    "ON": "ТӨРӨЛТ",
    "OFF": "ТҮГЖИХ",
    "btnAddSchedule": "Сэргээх",
    "EditSchedulelist": "Хуваарилагчийг засах",
    "AddSchedulelist": "Хуваарилагчийг нэмэх",
    "RestoreSchedulelist": "Сэргээх",
    "btn": "Цуцлах",
    "btnNewList": "Шинэ хуваарилагч",
    "ListName": "Нэр",
    "Cannotquit": "Албан ёсны",
    "NOCannotquit": "Үгүй",
    "ListValidityPeriod": "Хүчинтэй хугацаа",
    "ListDescription": "Тайлбар",
    "currentSchedule": "Хуваарилагчийн жагсаалт",
    "historySchedule": "Түүхийн жагсаалт",
    "selectTime": "Цаг",
    "selectTimeTable": "Цаг",
    "taskType": "Үүргийн төрөл",
    "selectBroadcasting": "Трансляци",
    "selectDeviveControl": "Төхөөрөмжийн хяналт",
    "newSchedule": "Шинэ үүрэг",
    "newChecklist": "Шинэ шалгуур жагсаалт",
    "titleStatus": "Төслийн байдал",
    "titleType": "Төрөл",
    "titleStartTime": "Эхлэх цаг",
    "titleEndTime": "Төгсгөл цаг",
    "titleRepeat": "Давтах",
    "titleName": "Нэр",
    "titleAction": "Үйлдэл",
    "tableEnabled": "Идэвхжүүлсэн",
    "tablePaused": "Тамгадах",
    "tableEdit": "Засах",
    "tableDelete": "Устгах",
    "tableVolumeEdit": "Трансляцийн дууны хэмжээ",
    "tableBroadcastTitle": "Гарчиг",
    "tableBroadcastContent": "Агуулга",
    "tableBroadcastList": "Жагсаалт",
    "tableBroadcast": "Албан ёсны",
    "btnRemoveCompletely": "Бүрэн устгах",
    "btnEnabled": "Идэвхтэй ажил",
    "btnPaused": "Ажил хаах",
    "btnDelete": "Устгах",
    "repeat0": "ДА",
    "repeat1": "МЯ",
    "repeat2": "ЛХ",
    "repeat3": "ПҮ",
    "repeat4": "БА",
    "repeat5": "БЯ",
    "repeat6": "НЯ",
    "dialogTitleAdd": "Шинэ төхөөрөмжийн хяналтын ажил",
    "dialogTitleEdit": "Төхөөрөмжийн хяналтын ажлыг засах",
    "newBroadcastingSchedule": "Шинэ трансляцийн ажил",
    "editBroadcastingSchedule": "Трансляцийн ажлыг засах",
    "chooseDevice": "Төхөөрөмж сонгох",
    "timeSetting": "Цагийн тохиргоо",
    "controlBroadcasting": "Трансляцийн сонголт",
    "controlOption": "Хяналтын сонголт",
    "scheduleName": "Ажил нэр:",
    "destination": "Зорилго",
    "timeTilte": "Цаг",
    "repeatTitle": "Давталт",
    "dialogRepeat0": "ДА",
    "dialogRepeat1": "МЯ",
    "dialogRepeat2": "ЛХ",
    "dialogRepeat3": "ПҮ",
    "dialogRepeat4": "БА",
    "dialogRepeat5": "БЯ",
    "dialogRepeat6": "НЯ",
    "dialogOnceType": "Нэг удаа",
    "dialogRepeatType": "Давталт",
    "Manual": "Ручной",
    "ManualContent": "Тохиргоог дуусгасан бол эдгээр ажлуудыг гарын авлагаар гүйцэтгэж болно.",
    "mainPower": "Үндсэн цахилгаан",
    "powerControl": "Цахилгаан хяналт",
    "tableDisplayInputSwitch": "Дисплей оролтын шилжүүлэгч",
    "tableAirConditioning": "Агааржуулагч",
    "tableProjectionScreen": "Проекцийн дэлгэц",
    "tableElectronicLock": "Цахилгаан түлхүүр",
    "interactiveFlatPanel": "Интерактив хавтгай самбар",
    "displayInputSwitch": "Дисплей оролтын шилжүүлэгч",
    "speakerVolume": "Дууны хэмжээ",
    "MICVolume": "Микрофон дууны хэмжээ",
    "ProjectionScreen": "Проекцийн дэлгэц",
    "ElectronicLock": "Цахилгаан түлхүүр",
    "AirConditioning": "Агааржуулагч",
    "AirConditioningPower": "Цахилгаан",
    "AirConditioningModel": "Загвар",
    "AirConditioningTEMP": "Температур",
    "AirConditioningFanSpeed": "Сэнсний хурд",
    "OPEN": "Нээх",
    "CLOSE": "Хаах",
    "UP": "ДООР",
    "DOWN": "ДЭЭШ",
    "PowerOFF": "ТҮГЭЭМЭЛ",
    "PowerON": "Онцгой",
    "ModelAuto": "Авто",
    "ModelCool": "Хөргөх",
    "ModelHeat": "Халаах",
    "ModelAir": "Агаарын тал",
    "TEMPLow": "Бага",
    "TEMPMiddle": "Дунд",
    "TEMPHigh": "Өндөр",
    "btnSave": "Хадгалах",
    "btnNext": "ДАРАА",
    "StartTime": "Эхлэх цаг",
    "StopTime": "Төрсөн цаг",
    "Mandatory": "Албан ёсны",
    "Video": "Видео ба Аудио",
    "Notification": "Мэдэгдэл",
    "btnFile": "Медиа файл сонгох",
    "LastingTime": "Хугацаа",
    "textTitle": "Гарчиг",
    "textContent": "Агуулга",
    "textTitleLetters": "60 тэмдэгтээс бага",
    "textContentLetters": "320 тэмдэгтээс бага",
    "CannotquitYES": "ТИЙМ",
    "CannotquitNo": "Үгүй",
    "YES": "Та энэ хуваарьг устгах гэж байна уу?",
    "No": "Устгасан хуваарь түүхийн жагсаалтад шилжиж, сэргээгдэх боломжтой болно",
    "delTitleContent": "Хуваарьг устгах уу?",
    "delTitleListContent": "Хуваарийг устгах нь холбогдсон даалгавруудыг цэвэрлэж, баталгаажуулна уу.",
    "deleListTitle": "Та энэ хуваарьг устгах гэж байна уу?",
    "delTitleListContent1": "Устгах?",
    "deleListTitle1": "Төгсгөл",
    "delTitle": "БҮХ",
    "btnConfirm": "Трансляцийн",
    "coxAll": "Төхөөрөмжийн хяналт",
    "coxBroadcasting": "ТИЙМ",
    "coxDeviveControl": "Үгүй",
    "rdMandatory": "Эхлэх огноо",
    "noRdMandatory": "Төрсөн огноо",
    "startDate": "-",
    "endedDate": "Төрөл",
    "or": "Цаг сонгох",
    "broadcastingType": "Огноо сонгох",
    "ChooseTime": "Шинэ хуваарь",
    "ChooseDate": "Хуваарь засах",
    "newScheduleList": "Нэр",
    "editScheduleList": "Тунхаглалын хугацаа",
    "listName": "Тайлбар",
    "listValidityPeriod": "Цуцлах",
    "listDescription": "Төгсгөл",
    "cancel": "Цуцлах",
    "confirm": "Баталгаажуулах",
    "save": "Хадгалах",
    "addSuccess": "Амжилттай нэмэгдсэн!",
    "addError": "Нэмэхэд алдаа гарлаа!",
    "editSuccess": "Амжилттай засварласан!",
    "editError": "Засварлахад алдаа гарлаа!",
    "delSuccess": "Амжилттай устгасан!",
    "delError": "Устгахад алдаа гарлаа!",
    "restoreSuccess": "Хуваарийн жагсаалт амжилттай сэргээгдсэн",
    "restoreError": "Хуваарийн жагсаалт сэргээхэд алдаа гарлаа",
    "restoreTitleContent": "Энэ цаг нь жагсаалтад байгаа цагтай зөрчилдөж байна, дахин сонгоно уу",
    "Enabled": "Идэвхтэй",
    "Paused": "Түр зогсоох",
    "Title": "Гарчиг:",
    "Content": "Агуулга:",
    "errorScheduleNameRequired": "Үүргийн нэрийг бөглөх шаардлагатай",
    "errorDeviceRequired": "Зорилтот төхөөрөмжийг сонгоно уу",
    "deleTitle": "Та энэ үүргийг устгах гэж байна уу?",
    "loopList": "Лупийн жагсаалт",
    "errorPleaseDateRange": "Огнооны хүрээг сонгоно уу",
    "addError_2009": "Давхардсан хуваарь нэр",
    "conflicts": "Үүргийн цаг дараахтай зөрчилдөж байна:",
    "Pleaseagain": "Дахин оруулна уу",
    "errorScheduleName": "Үүргийн нэр",
    "errorListName": "Хуваарийн нэр",
    "today": "Өнөөдөр",
    "yesterday": "Өчигдөр",
    "thisWeek": "Энэ долоо хоногт",
    "lastWeek": "Өнгөрсөн долоо хоногт",
    "lastMonth": "Өнгөрсөн сард",
    "thisMonth": "Энэ сард",
    "times": "Үед",
    "TimeConflicts": "Цагийн зөрчил",
    "editError_2006": "Төхөөрөмж олдсонгүй",
    "editError_2010": "Давхардсан үүргийн нэр",
    "editError_2100": "Үүрэг хугацаа дууссан, эхлүүлж болохгүй.",
    "ListTimeExpired": "Хуваарийн цаг дууссан, дахин сонгоно уу",
    "TimeExpired": "Цаг дууссан",
    "ControlOption": "Хяналтын сонголт алга",
    "Pleaseleastone": "Ядаж нэг хяналтын сонголт сонгоно уу",
    "Enter": "Оруулах",
    "TitleFilled": "Гарчиг бөглөх шаардлагатай",
    "ContentFilled": "Агуулга бөглөх шаардлагатай",
    "PleaseMediaFile": "Медиа файлыг сонгоно уу",
    "PleaseSchedule": "Үүргийг сонгоно уу",
    "delTitleScheduleContent": "Устгасан үүрэг сэргээгдэхгүй.",
    "deleTitleSchedule": "Та энэ үүргийг устгах гэж байна уу?",
    "deleteScheduleTitle": "Устгах үүргийг сонгоно уу",
    "PleaseFillColumn": "Хуваарийн нэрийг бөглөнө үү",
    "PleaseDate": "Огноо сонгоно уу",
    "Previous": "Өмнөх",
    "RemoteControl": "Алсаас хяналт",
    "taskhasexpired": "Энэ үүрэг дууссан тул, цагийг шинэчлэхийн тулд бүтээгчтэй холбоо барина уу",
    "execute": "Гүйцэтгэх",
    "broadcastingList": "Трансляцийн жагсаалт",
    "volumeSuccess": "Дууны түвшинг амжилттай тохируулав",
    "volumeFailed": "Дууны түвшинг тохируулахад алдаа гарлаа"
  },
  "live": {
    "StreamingRoom": "Стримийн өрөө",
    "btnAddNewRoom": "Шинэ өрөө нэмэх",
    "Steaming": "Стриминг",
    "Creater": "хост:",
    "Address": "RTMP хаяг:",
    "StreamingURL": "Шууд дамжуулалтын URL:",
    "DestinationNMP": "NMP зорилтыг сонгоно уу:",
    "stop": "ЗОГСООХ",
    "stat": "ЭХЛҮҮЛЭХ",
    "btnCope": "Хуулж авахын тулд дарна уу",
    "QRcode": "QR код",
    "Refresh": "Шинэчлэлт",
    "AddNewRoomTitle": "Шинэ стриминг өрөө нэмэх",
    "editNewRoomTitle": "Стриминг өрөөг засварлах",
    "roomName": "Өрөөний нэр:",
    "cancel": "Цуцлах",
    "confirm": "Батлах",
    "save": "Хадгалах",
    "delTitleContent": "Та энэ хуваарьг устгах гэж байгаа юу?",
    "delTitle": "Устгах?",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Батлах",
    "addSuccess": "Амжилттай нэмэгдсэн!",
    "addError": "Нэмэхэд алдаа гарсан!",
    "editSuccess": "Амжилттай засварласан!",
    "editError": "Засварлахад алдаа гарсан!",
    "delSuccess": "Амжилттай устгасан!",
    "delError": "Устгахад алдаа гарсан!",
    "Stopstreaming": "Стриминг зогсоох",
    "Startstreaming": "Стриминг эхлүүлэх",
    "error2504": "Медиа серверээс шууд дамжуулалтын хаягийг авах боломжгүй",
    "error2505": "Стриминг өрөөний нэр давхардаж байна",
    "error2506": "Төхөөрөмжийг өөр стримингийн дохио эзэлсэн байна",
    "error1900": "Хүрэх параметр хоосон байна",
    "error2503": "Медиа серверийн мэдээллийг авах боломжгүй",
    "error2507": "Шууд дамжуулалтын хаяг давхардаж байна",
    "copySuccess": "Агуулгыг clipboard руу хуулсан.",
    "copyError": "Браузер автоматаар хуулж авахыг дэмжихгүй",
    "flashControl": "Flash суулгагдаагүй эсвэл идэвхжээгүй байна. Flash суулгагдсаны дараа дахин оролдож үзнэ үү.",
    "liveStreaming": "Шууд дамжуулалтын эх үүсвэр олдсонгүй.",
    "btnflash": "Суулгах/Идэвхжүүлэх",
    "serverAddress": "Серверийн хаяг",
    "addressKey": "Түлхүүр:",
    "watchingAddress": "Үзэх хаяг",
    "audioOnly": "Зөвхөн аудио",
    "enterTheKey": "Түлхүүрийг бөглөх шаардлагатай."
  },
  "guidepages": {
    "next": "Дараагийн төхөөрөмжийн удирдлага",
    "next1": "Дараагийн удирдах оролдлого",
    "next2": "Дараагийн шууд дамжуулалт",
    "next3": "Дараагийн шууд дамжуулалтыг эхлүүлэх",
    "next4": "Дараагийн шууд дамжуулалтыг зогсоох",
    "next5": "Дараагийн текст дамжуулалт",
    "next6": "Дараагийн даалгавар тохируулах",
    "next7": "Дараагийн шинэ даалгавар нэмэх",
    "next8": "Дараагийн түүхийн жагсаалт",
    "next9": "Дараагийн үүл хадгалах",
    "next10": "Дараагийн шууд дамжуулалт",
    "next11": "Дараагийн шууд дамжуулалтыг тохируулах",
    "exit": "Гарах",
    "guideContent": "Гарын авлагын агуулга",
    "btnHomepage": "Нүүр хуудас",
    "btnDevices": "Төхөөрөмжүүд",
    "btnBroadcast": "Дамжуулалт",
    "btnSchedule": "Хуваарь",
    "btnResources": "Нөөцүүд",
    "btnStreaming": "Стриминг",
    "btnPrevious": "Өмнөх"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/mn.js